import { IOption } from '../interfaces/FormFields'

export const MAIN_IDENTITY_DOCUMENT: IOption[] = [
  { value: '1', label: 'Carte Nationale d’Identité' },
  { value: '2', label: 'Passeport' },
  { value: '3', label: 'Titre de séjour' },
  { value: '4', label: 'Autres' },
]
export const IDENTITY_DOCUMENT_TYPE: IOption[] = [
  { value: '', label: 'Choisir une option...' },
  ...MAIN_IDENTITY_DOCUMENT,
]

export const OTHER_INPUT_TYPE: IOption[] = [
  { value: '', label: 'Choisir une option...' },
  { value: '1', label: 'Carte de résident' },
  { value: '2', label: 'Récépissé de demande de carte de séjour' },
  { value: '3', label: 'Carte de séjour' },
]
